import React, { useContext, useEffect, useState } from 'react'
import { Content, LoadingMessage } from './style'
import SectionContext from '../../../contexts/SectionContext'
import LoadingComponent from '../../../components/LoadingComponent'
import { ButtonCreate, LeftSide, OptionsButton, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from '../../../components/subheader-style'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import certificate from '../../../assets/certificates/SubHeader/certificate.svg'
import param from '../../../assets/certificates/SubHeader/param.svg'
import CertificatesContext, { initialCertificateState } from '../../../contexts/CertificatesContext'
import ModalContext from '../../../contexts/ModalContext'

export interface CertificateOutletType {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
}

const tabs = [
  { path:'', image: certificate, name: 'Certificados' },
  { path:'params', image: param, name: 'Parâmetros' },
]

const CertificateSubHeader:React.FC<{tabIndexActived: number | null}> = ({tabIndexActived}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { setCertificate } = useContext(CertificatesContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)
  
  const handleCreateCertificate = () => {
    setCertificate(initialCertificateState)
    setModalSection('addCertificateMenu')
    setModalActive(true)
  }
  
  return(
    <SubHeaderContainer>
    <LeftSide>
      <SectionName>
        {location.pathname.includes('create') ? `${tabIndexActived === 1 ? 'Parâmetro da norma' : 'Novo certificado'}`: 'Certificados'}
      </SectionName>
      {!location.pathname.includes('create') &&
        <TabsDiv>
          {tabs.map((tab, index) => (
          <Tab
            key={index}
            $isFirst={index === 0}
            $isLast={index === tabs.length - 1}
            $isActive={tabIndexActived === index}
            onClick={() => {
              if(index !== tabIndexActived) navigate(tab.path)
            }}
          >
              <img src={tab.image} alt={`${tab.path}-icon`} />
              {tab.name}
            </Tab>
          ))}
        </TabsDiv>
      }
    </LeftSide>
    {!location.pathname.includes('create') &&
      <RightSide>
        {/* <OptionsButton>f</OptionsButton>
        <OptionsButton>o</OptionsButton> */}
        <ButtonCreate onClick={() => {
          if(tabIndexActived === 0) return handleCreateCertificate()
          return navigate('/panel/certificates/params/create')
        }}>+ Criar {tabIndexActived === 0 ? 'certificado' : 'parâmetro'}</ButtonCreate>
      </RightSide>
    }
  </SubHeaderContainer>
  )
}

const CertificatesContent: React.FC = () => {
  const [ loading, setLoading ] = useState<boolean>(false)
  const [ tabIndex, setTabIndex ] = useState<number | null>(null)

  return (
    <>
      <CertificateSubHeader tabIndexActived={tabIndex} />
      {loading === true && <LoadingComponent />}
      <Content>
        <Outlet
          context={{
            tabIndex,
            setTabIndex
          }}
        />
      </Content>
    </>
  )
}
export default CertificatesContent
